import axios from '../axios'

// 查询
export const selectByPage = (data) => {
    return axios({
        url: '/admin/advertise/selectByPage',
        method: 'post',
        data
    })
}

export const insert = (data) => {
    return axios({
        url: '/admin/advertise/insert',
        method: 'post',
        data
    })
}

export const batchDisabled = (data) => {
    return axios({
        url: '/admin/advertise/batchDisabled',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/admin/advertise/batchEnable',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/advertise/batchDelete',
        method: 'post',
        data
    })
}

export const update = (data) => {
    return axios({
        url: '/admin/advertise/update',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/advertise.js